var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('span',{staticClass:"ii-logo"},[_c('img',{staticClass:"ii-logo__mark",attrs:{"src":"/ininvoice-mark.svg","alt":"","aria-hidden":"true"}}),_c('span',{staticClass:"ii-logo__text"},[_vm._v("ininvoice")])])
}]

export { render, staticRenderFns }